import { ChangeDetectionStrategy, Component, input, output, type InputSignal, type OutputEmitterRef } from '@angular/core';
import { UiIconButtonComponent } from '@nexus/frontend-shared-ui';
import type { WishlistOverviewHeroView } from '../../types/wishlist-overview-hero-view.interface';

@Component({
  selector: 'wishlist-overview-hero',
  imports: [UiIconButtonComponent],
  templateUrl: './wishlist-overview-hero.component.html',
  styleUrl: './wishlist-overview-hero.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistOverviewHeroComponent {
  public readonly view: InputSignal<WishlistOverviewHeroView> = input.required<WishlistOverviewHeroView>();
  public readonly createSelected: OutputEmitterRef<void> = output<void>();
  public readonly searchSelected: OutputEmitterRef<void> = output<void>();

  protected handleCreateSelected(): void {
    this.createSelected.emit();
  }

  protected handleSearchSelected(): void {
    this.searchSelected.emit();
  }
}
